/**
 * One action and the keys that trigger it. `keys` lists alternatives; each
 * alternative is a combination pressed together, e.g. `[['⌘', 'K']]` or
 * `[['↑'], ['↓']]`.
 */
export interface KeyboardShortcut {
  keys: readonly (readonly string[])[];
  label: string;
}

export interface KeyboardShortcutGroup {
  title: string;
  shortcuts: readonly KeyboardShortcut[];
}

/** Spoken names for the glyphs, so a screen reader says "Command K". */
const KEY_NAMES: Record<string, string> = {
  '⌘': 'Command',
  '⌥': 'Option',
  '⇧': 'Shift',
  '⌃': 'Control',
  '↵': 'Enter',
  '⌫': 'Delete',
  Esc: 'Escape',
  '↑': 'Up arrow',
  '↓': 'Down arrow',
  '←': 'Left arrow',
  '→': 'Right arrow',
  '?': 'Question mark',
  '/': 'Slash',
  ',': 'Comma'
};

export const describeKeys = (combo: readonly string[]) =>
  combo.map((key) => KEY_NAMES[key] ?? key).join(' ');
